import {
  getEducation,
  getWorkStatus,
} from "Store/advice/productPriceRequestMappers/disabilityPriceRequestMapper";

import { DisabilityProductBackend } from "Components/Features/CheckPrice/Products/Advice/mappers/mapToCommerceDisability";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { mapOneTimePayment } from "../mapToPriceRequest/mapToDisabilityPriceReq";
import { mapHasEmployerPaidDisabilityInsurance } from "../utils";
import { MappingData } from "./mapToCartProducts";

export const mapToDisabilityProduct = (
  isAdvisor: boolean,
  data: MappingData,
): DisabilityProductBackend => {
  const detailsFormValues = data.detailsFormData;
  const priceFormValues = data.priceFormData;

  return {
    name: INSURANCE_NAME_VALUE.DISABILITY_FLEX,
    coverageGroup: data.priceData[0].configurationName,
    customerRef: data.customerData.newCustomerResponse.customerRef,
    dateOfBirth: data.customerData.newCustomerResponse.dateOfBirth ?? "",
    education: getEducation(detailsFormValues.education),
    hasEmployerPaidDisabilityInsurance:
      mapHasEmployerPaidDisabilityInsurance(detailsFormValues),
    coverageAmountCapital: mapOneTimePayment(isAdvisor, priceFormValues),
    insuredSum: priceFormValues.disabilityInsuredSumSlider ?? 0,
    paymentAfter3Months: priceFormValues.disabilityPaymentAfter3Months ?? false,
    workStatus: getWorkStatus(detailsFormValues.workSituation),
    yearlyIncome: detailsFormValues.income,
    isFemale: data.customerData.newCustomerResponse.isFemale,
    isScandinavianCitizen: true,
    isSmoker: false,
    isStayingInNorwayForMoreThanFiveYears: true,
  };
};
